import axios from "axios";
import React, { useEffect } from "react";
import CheckBox from "../../../../Components/CheckBox/CheckBox";
import Modal from "../../../../Components/Modal/Modal";
import Stepper from "../../../../Components/Stepper/Stepper";
import { Button, Input, Textarea } from "../../../../Components/StyledComponents";
import { onlyNum } from "../../../../Utils/functions";
import './CreateMenu.scss';
import {cloneDeep} from 'lodash-es';
import ReactDragListView from 'react-drag-listview';

/* ***
CreateMenu 참고
*** */

const ModifyMenu = ({info,patchMenu}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState('')
    const [ price, setPrice ] = React.useState([{ Name : '', Price : 0 }])
    const [ desc, setDesc ] = React.useState('')
    const [ options, setOptions ] = React.useState([]);
    const [ optionIds, setOptionIds ] = React.useState([]);
    const [ optionList, setOptionList ] = React.useState([]);

    useEffect(() => {
        getOptionGroup();
        setName(cloneDeep(info.Name));
        setPrice(cloneDeep(info.Price));
        setDesc(cloneDeep(info.Description));
        
    },[])

    const getOptionGroup = () => {
        axios.get('/api/order/menu/option/group')
        .then((data)=>{
            let arr = [];
            let newarr = []
            setOptionList(data.data)
            for( let i=0; i < info.OptionGroupIds.length; i++){
                arr.push(info.OptionGroupIds[i].$oid)
                let index = data.data.findIndex( item => item._id.$oid === info.OptionGroupIds[i].$oid)
                newarr.push(data.data[index])
            }
            setOptionIds(arr)
            /* for(let i=0; i < data.data.length; i++){
                if( arr.indexOf(data.data[i]._id.$oid) !== -1){
                    newarr.push(data.data[i])
                }
            } */
            setOptions(newarr)
        })
    }


    const optionRef = React.useRef(null)

    const addPrice = () => {
        setPrice(old => [...old,{ Name : '', Price : 0}])
    }

    const handlePriceName = (val,i) => {
        let arr = price;

        arr[i].Name = val;

        setPrice([...arr])
    }

    const handlePricePrice = (val,i) => {
        let arr = price;

        arr[i].Price = val;

        setPrice([...arr])
    }

    const removePrice = (i) => {
        let arr = price;

        arr.splice(i,1);

        setPrice([...arr])
    }

    const nextStep = () => {
        if(step !== 4) setStep(old => old+1)
        else patch()
    }

    const handleOptions = (data) => {
        let index;

        index = optionIds.findIndex(item => item === data._id.$oid)

        if(index === -1){
            setOptionIds(old => [...old,data._id.$oid])
            setOptions(old => [...old,data])
        }else {
            setOptionIds(optionIds.filter(item => item !== data._id.$oid));
            setOptions(options.filter(item => item._id.$oid !== data._id.$oid))
        }
    }

    const getChecked = (id) => {
        let index = optionIds.findIndex(item => item === id);
        if( index === -1 ) return false;
        else return true
    }

    const isDisabled = () => {
        if(step === 1 && ( name.trim() === '' || price.length === 0 || price[0].Name.trim() === '' )) return true;
        else return false
    }

    const patch = () => {
        let arr = [];
        for(let i=0; i < price.length; i++){
            arr.push({Name : price[i].Name, Price : parseInt(price[i].Price )})
        }

        patchMenu({
            MenuId : info._id.$oid,
            Name : name,
            Description : desc,
            Price : arr,
            OptionGroupIds : optionIds
        })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
          const data = [...options];
          const item = data.splice(fromIndex, 1)[0];
          data.splice(toIndex, 0, item);
          setOptions([...data]);

          const ids = [...optionIds];
          const id = ids.splice(fromIndex,1)[0];
          ids.splice(toIndex,0,id)
          setOptionIds([...ids])
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName : 'line',
    };


    return (
        <div className="create-menu">
            <Stepper maxStep={4} step={step} containerStyle={{ marginBottom : step === 4 ? 0 : 40 }}/>
            {
                step === 4 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <div>
                    <div className="row">
                        <p className="label">메뉴명</p>
                        
                        <Input value={name} placeholder={"예) 매운떡볶이"} onChange={(e) => setName(e.target.value)} style={{ width : 351 }} />
                    </div>

                    <div style={{ marginTop : 32, marginBottom : 16 }}>
                        <p className="label">가격구성</p>
                        {
                            price.map((data,i) => {
                                return (
                                    <div className="row" key={i} style={{ marginTop : 16 }}>
                                        <Input value={price[i].Name} onChange={(e) => handlePriceName(e.target.value,i)} placeholder="예) 1인분, 300g 등" style={{ width : 180, marginRight : 16 }}/>
                                        <label htmlFor={`price${i}`} data-domain="원">
                                            <Input htmlFor={`price${i}`} value={price[i].Price} onChange={(e) => handlePricePrice(onlyNum(e.target.value),i)} placeholder="0" style={{ width : 180 }}/>
                                        </label>
                                        <Button variant="sub" onClick={()=> removePrice(i)} style={{ width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 16 }}>
                                            <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 16, height : 16, marginTop : 6 }} />
                                        </Button>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <Button variant="sub" onClick={() => addPrice()} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                        <div className='row'>
                            <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            추가하기
                        </div>
                    </Button>
                </div>                    
            }

            {
                step === 2 &&
                <div className='row' style={{ alignItems : 'flex-start' }}>
                    <p className='label'>설명(선택)</p>
                    <Textarea
                        value={desc}
                        onChange={(e) => setDesc(e.target.value)}
                        style={{ width : 347, height : 173 }}
                        placeholder="예) 세트 구성 메뉴입니다."
                    />
                </div>
            }

            {
                step === 3 &&
                <div>
                    <div className="row between" style={{ marginBottom : 8 }}>
                        <p className="label" style={{ width : 'fit-content' }}>옵션 추가 (선택)</p>
                        <Button variant="sub" small onClick={() => optionRef.current.openModal()}>
                            <div className='row'>
                                <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                                추가하기
                            </div>
                        </Button>
                    </div>
                    <ReactDragListView {...dragProps}>
                    {
                        options.length === 0 ?
                        <p className="label" style={{ opacity : 0.5, width : 'fit-content' }}>메뉴 주문시 메뉴의 맛이나 토핑, 추가메뉴,음료 등의<br/> 옵션메뉴를 설정할 수 있어요.</p>
                        :
                        <div>
                            {
                                options.map((data,i)=> {
                                    return(
                                        <li key={i}>
                                            <div className="option-select-box" style={{ marginBottom : i === options.length - 1 ? 0 : 8 }}>
                                                <div className="row">
                                                    <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width : 24, height : 24, userSelect : 'none', marginRight : 8, pointerEvents : 'none' }} />
                                                    <p className="option-title" style={{ marginLeft : 0 }}>{data.Name}</p>
                                                </div>
                                                <p className="option-desc">
                                                    {
                                                        data.OptionInfo.map((item,index) => {
                                                            return item.Name + ( index === data.OptionInfo.length - 1 ? '' : ',')
                                                        })
                                                    }
                                                </p>
                                                {
                                                    data.ConnectedMenuInfo.length > 0 && 
                                                    <div className="option-related-box">
                                                        <div className="option-related-title-box">
                                                            <p className="options-related-title">옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                                        </div>
                                                        <p className="option-related-desc">
                                                            {
                                                                data.ConnectedMenuInfo.map((item,index) => {
                                                                    return item.Name + ( index === data.ConnectedMenuInfo.length - 1 ? '' : ',')
                                                                })
                                                            }
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </div>
                    }
                    </ReactDragListView>
                </div>
            }

            {
                step === 4 &&
                <div>
                    <p className="label" style={{ marginTop : 16 }}>메뉴명</p>
                    <p className="text">{name}</p>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>가격 구성</p>
                    <div style={{ marginTop : 8, marginBottom : 16 }}>
                    {
                        price.map((data,i) => {
                            return (
                                <p key={i} className="text" style={{ margin : 0}}>{data.Name + ' : ' + data.Price}</p>
                            )
                        })
                    }
                    </div>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>메뉴설명</p>
                    {
                        desc === '' ?
                        <p className="text-none">등록된 내용이 없어요.</p>
                        :
                        <p className="text">{desc}</p>
                    }
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16, marginBottom : 8 }}>옵션그룹</p>
                    {
                        options.map((data,i) => {
                            return (
                                <div className="option-select-box" style={{ marginBottom : i === options.length - 1 ? 0 : 8 }} key={i}>
                                    <div className="row">
                                        <p className="option-title">{data.Name}</p>
                                    </div>
                                    <p className="option-desc">
                                        {data.OptionInfo.map((item,index) => item.Name + ( index === data.OptionInfo.length - 1 ? '' : ','))}
                                    </p>
                                    <div className="option-related-box">
                                        <div className="option-related-title-box">
                                            <p className="options-related-title">옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                        </div>
                                        <p className="option-related-desc">
                                            {data.ConnectedMenuInfo.map((item,index) => item.Name + ( index === data.ConnectedMenuInfo.length - 1 ? '' : ','))}
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }


            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 4 ? '수정하기' : '다음'}
                </Button>
            </div>

            <Modal ref={optionRef} contentContainer={{ width : 500, height : '80%', overflow : 'scroll' }} isHeader title={'옵션 선택'}>
                <>
                {
                    optionList.length > 0 &&
                    <div>
                        {
                            optionList.map((data,i) => {
                                return (
                                    <div className="option-select-box" key={i} style={{ marginBottom : i === optionList.length - 1 ? 0 : 8 }}>
                                        <div className="row">
                                            <CheckBox containerStyle={{ marginBottom : 24 }} checked={getChecked(data._id.$oid)} label="" onChange={() => handleOptions(data)} />
                                            <p className="option-title">{data.Name}</p>
                                        </div>
                                        <p className="option-desc">
                                        {
                                            data.OptionInfo.map((item,index) => {
                                                return item.Name + ( index === data.OptionInfo.length - 1 ? '' : ',')
                                            })
                                        }
                                        </p>
                                        {
                                            data.ConnectedMenuInfo.length > 0 && 
                                            <div className="option-related-box">
                                                <div className="option-related-title-box">
                                                    <p className="options-related-title">옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                                </div>
                                                <p className="option-related-desc">
                                                    {
                                                        data.ConnectedMenuInfo.map((item,index) => {
                                                            return item.Name + ( index === data.ConnectedMenuInfo.length - 1 ? '' : ',')
                                                        })
                                                    }
                                                </p>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                        <div className='btn-row'>
                            <Button variant="main" className='save-btn' fontSize={16} onClick={() => optionRef.current.closeModal()}>
                                확인
                            </Button>
                        </div>
                    </div>
                }
                </>
            </Modal>
        </div>
    )
}

export default ModifyMenu;